import React from "react";
import { Redirect } from "react-router-dom";
import { paths } from "testly-web/paths";

export const RedirectOnNotFound: React.SFC = () => {
  return <Redirect to={paths.projectRedirectPath()} />;
};
